import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Spinner} from '@npck/libs/commons';

@Component({
    selector: 'ui-kit-button',
    templateUrl: 'button.component.html',
    styleUrls: ['button.component.scss'],
    standalone: false,
})
export class ButtonComponent implements OnInit, AfterViewInit {
    @ViewChild('button', {read: ElementRef}) button: ElementRef<HTMLButtonElement>;
    @Input() disabled = false;
    /**
     * @deprecated Should use size property instead
     */
    @Input() isSmall = false;
    @Input() fitContent = false;
    @Input() removePadding = false;
    @Input() label: string = '';
    @Input() type: ButtonType = 'primary';
    @Input() size: ButtonSize = 'default';
    @Input() color: ButtonColor = 'primary';
    @Input() icon: string;
    @Input() iconPosition: ButtonIconPosition = 'none';
    @Input() spinnerId: string;
    @Input() autoFocus = false;
    @Input() buttonType: 'button' | 'submit' = 'submit';
    @Input() testId: string;
    @Output() clickListener = new EventEmitter<void>();
    smallSizes: ButtonSize[] = ['small', 'extra-small'];
    Spinner = Spinner;

    ngOnInit(): void {
        if (this.isSmall) {
            this.size = 'small';
        }
    }

    ngAfterViewInit(): void {
        if (this.autoFocus) {
            setTimeout(() => this.button.nativeElement.focus(), 100);
        }
    }
}

export type ButtonSize = 'default' | 'small' | 'extra-small';
export type ButtonType = 'primary' | 'secondary' | 'white' | 'text';
export type ButtonColor = 'primary' | 'accent' | 'orange';
export type ButtonIconPosition = 'left' | 'right' | 'none';
